export default __webpack_public_path__ + "static/media/WritingDesk.f0a3e84a.gltf";